export { mapFundingEntity } from '@roc/feature-loan-details';
